"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentWorkspaceIdReducerBase = void 0;
var currentWorkspaceIdReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === 'SET_CURRENT_WORKSPACE_ID_ACTION') {
        return action.workspaceId;
    }
    return state || null;
};
exports.currentWorkspaceIdReducerBase = currentWorkspaceIdReducerBase;
